import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { AffiliateInput } from '@/models/affiliate';

export const updateAffiliate = async ({ data, codeName }: { data: AffiliateInput; codeName: string }) => {
  const response = await mutationExecute({
    variables: {
      data,
      codeName,
    },
    mutation: graphql(`
      mutation UpdateAffiliate($data: AffiliateInputType!, $codeName: String!) {
        updateAffiliate(data: $data, codeName: $codeName) {
          id
          name
          codeName
          extension
          phoneNumber
          gogoNumber
          email
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          currency
          timeZone
          description
          isDisabled
          logoUrl
        }
      }
    `),
  });

  return response.data?.updateAffiliate!;
};
